import { render, staticRenderFns } from "./SettingsCountryDropdown.vue?vue&type=template&id=2b38472f&scoped=true&"
import script from "./SettingsCountryDropdown.vue?vue&type=script&lang=js&"
export * from "./SettingsCountryDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SettingsCountryDropdown.vue?vue&type=style&index=0&id=2b38472f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b38472f",
  null
  
)

export default component.exports